
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35435',
  depVersions: {
  "documents-public-ui": "static-1.35435",
  "atom": "static-1.5488",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2893",
  "client-types": "static-1.505",
  "cssUtils": "static-1.1031",
  "customer-data-filters-ui": "static-1.41202",
  "customer-data-objects": "static-1.8103",
  "customer-data-property-utils": "static-1.8464",
  "documents-lib": "static-1.35440",
  "emoji-mart": "static-3.6",
  "flux-actions": "static-1.378",
  "FormsCommonComponents": "static-1.86736",
  "FormUrlGenerator": "static-2.5123",
  "foundations-theming-specialty": "static-1.2606",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.114",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6000",
  "hs-test-utils": "static-1.8449",
  "hub-http": "static-1.6619",
  "hubspot-dlb": "static-2.1911",
  "HubStyle": "static-2.12207",
  "HubStyleTokens": "static-2.11900",
  "I18n": "static-7.1691",
  "icons": "static-2.699",
  "jasmine-immutable": "static-1.3371",
  "jasmine-runner": "static-1.6858",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7561",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3297",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5790",
  "quartz": "static-1.7581",
  "react": "static-7.202",
  "react-dlb": "static-1.92",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17143",
  "react-select-plus": "static-1.116",
  "react-utils": "static-2.5621",
  "react-virtualized": "static-2.110",
  "reference-resolvers": "static-1.8590",
  "reference-resolvers-lite": "static-1.8514",
  "reporting-data": "static-1.69158",
  "reporting-reports": "static-1.68834",
  "reporting-snowflake": "static-1.57774",
  "reporting-testing-lib": "static-1.11091",
  "reporting-visualizations": "static-1.61232",
  "reselect": "static-3.15",
  "sales-content-partitioning": "static-1.9367",
  "sanitize": "static-1.4882",
  "sanitize-text": "static-1.8568",
  "SharedI18nStrings": "static-1.186",
  "SharedLegalStrings": "static-1.2137",
  "signup-constants": "static-1.19823",
  "signup-ui-url-generator": "static-2.8469",
  "StyleGuideUI": "static-3.512",
  "superstore": "static-1.5169",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5156",
  "ui-addon-form-validation": "static-1.11337",
  "ui-asset-management-lib": "static-1.11512",
  "ui-images": "static-2.1269",
  "UIComponents": "static-3.8846",
  "usage-tracker": "static-1.7723",
  "usage-tracker-container": "static-1.7713",
  "usage-tracker-core": "static-1.7573",
  "viral-links-lib": "static-1.7489",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.10056",
  "foundations-components": "static-1.8647",
  "immutable": "static-2.88",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1359",
  "quartz-core": "static-1.6800",
  "quick-fetch": "static-1.4190",
  "raven": "static-3.5925",
  "redux": "static-4.81",
  "redux-thunk": "static-2.83",
  "rpc-client-utils": "static-1.5079",
  "ui-addon-i18n": "static-1.11557",
  "ui-addon-upgrades": "static-9.18506",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4383",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3858",
  "quartz-webpack": "static-1.3805",
  "foundations-assets": "static-1.5296",
  "foundations-theming": "static-1.4890",
  "hub-http-janus": "static-1.896",
  "hub-http-shared-msw-handlers": "static-1.10792",
  "hubspotter-http": "static-1.4926",
  "sassPrefix": "static-1.298",
  "conversations-skeleton-state": "static-1.7602",
  "crm-message-bus": "static-1.43973",
  "customer-data-filters-ui-msw-helpers": "static-1.23637",
  "customer-data-objects-ui-components": "static-1.13439",
  "customer-data-reference-ui-components": "static-1.13576",
  "customer-data-ui-utilities": "static-1.10242",
  "events-data-lib": "static-1.657",
  "framework-builder-read-service-client": "static-1.4287",
  "hs-resources": "static-1.604",
  "immer": "static-1.104",
  "inbound-db-meta-service-client": "static-1.3739",
  "inbound-db-properties-service-client": "static-1.4107",
  "multi-account-reference-resolvers": "static-1.1412",
  "onboarding-scopes": "static-1.6862",
  "onboarding-tours": "static-1.17295",
  "pulse": "static-1.1048",
  "reporting-datasets-permissions-lib": "static-1.14655",
  "segments-client-types": "static-1.11943",
  "stylex": "static-1.45",
  "trellis-assets": "static-1.2932",
  "trellis-components": "static-1.2951",
  "trellis-theming": "static-1.1391",
  "ui-addon-teams": "static-1.21968",
  "quartz-auth": "static-1.1256",
  "ui-business-units-lib": "static-1.9504",
  "usage-tracker-session-replay": "static-1.5409",
  "ai-components-ui-library": "static-1.9912",
  "ContentUtils": "static-1.69330",
  "customer-data-properties": "static-1.52868",
  "forms-ai-lib": "static-1.4894",
  "forms-utils-lib": "static-1.13239",
  "foundations-components-test-utils": "static-1.6130",
  "react-dnd-compat": "static-1.5022",
  "react-tinymce": "static-1.56159",
  "tinymce-config": "static-2.55285",
  "ui-gdpr-components": "static-1.10649",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3875",
  "HeadJS": "static-2.811",
  "framer-motion": "static-1.82",
  "hs-test-utils-bend-plugin": "static-1.3560",
  "msw": "static-1.39",
  "msw-config": "static-1.16",
  "testing-library": "static-1.162",
  "hs-locale-management": "static-1.359",
  "ui-fonts": "static-1.1162",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4719",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1246",
  "web-vitals": "static-1.18",
  "batch-promise": "static-1.1956",
  "external-options-client-types": "static-1.4407",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7305",
  "quartz-i18n": "static-1.1256",
  "frontend-preferences-client": "static-1.8328",
  "graphql": "static-1.92",
  "persist-promise": "static-1.4113",
  "reporting-client-types": "static-1.2774",
  "apollo-stack-hubspot": "static-3.97",
  "growth-payments-core": "static-1.26382",
  "hubspot-apollo-client": "static-1.5285",
  "foundations-components-legacy": "static-1.1672",
  "quartz-routing": "static-1.1011",
  "hs-story-utils": "static-1.9836",
  "react-flip-move": "static-1.81",
  "nested-table": "static-1.647",
  "seat-types-lib": "static-1.927",
  "timezone-utils": "static-2.5641",
  "react-create-root-preference": "static-1.88",
  "bend-plugin-foundations-components": "static-1.4916",
  "floating-ui": "static-1.66",
  "react-aria": "static-1.75",
  "tanstack-table": "static-1.64",
  "opentelemetry-fe-types": "static-1.195",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.593",
  "module-federation": "static-1.36",
  "opentelemetry-fe": "static-1.570",
  "quartz-test": "static-1.1256",
  "quartz-tracking": "static-1.960",
  "bend-plugin-chirp-manifest": "static-1.489",
  "chirp-fetch": "static-1.2310",
  "merchandise-lib": "static-1.283",
  "purchase-motions-components": "static-1.6553",
  "ts-schema": "static-1.4359",
  "bender-build-tools": "static-1.3472",
  "bend-plugin-foundations-theming": "static-1.3373",
  "restore-request-side-panel-lib": "static-1.1899",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.5019",
  "conditional-properties-service-client": "static-1.4081",
  "crm-pipelines-api-client-types": "static-1.4412",
  "event-emitter": "static-1.1370",
  "fdsr-migration-layer": "static-1.424",
  "multi-currency-client-types": "static-1.3976",
  "getting-started-shared-tasks": "static-1.19450",
  "growth-data-modal": "static-1.6039",
  "growth-onboarding-confetti": "static-1.3473",
  "growth-onboarding-next-action-utils": "static-1.2875",
  "navigation-components": "static-1.19046",
  "onboarding-tours-client": "static-1.5510",
  "onboarding-tours-utils": "static-1.1362",
  "ui-shepherd-react": "static-3.10683",
  "ui-shepherd-tracker": "static-1.8064",
  "ui-universal-auth": "static-1.9609",
  "user-context": "static-1.5476",
  "bend-plugin-pulse": "static-1.551",
  "fast-json-patch": "static-1.73",
  "crm-index-associations-lib": "static-1.6858",
  "stylex-utils": "static-1.158",
  "base-ui": "static-1.25",
  "react-day-picker": "static-1.13",
  "tanstack-virtual": "static-1.41",
  "hubspotter-http-shared-msw-handlers": "static-1.10790",
  "magpie-lib": "static-1.5847",
  "navigation-messaging": "static-1.8373",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.23468",
  "copilot-toolkit": "static-1.12032",
  "cms-field-types": "static-1.5223",
  "content-icons-ui": "static-1.2417",
  "integrations-lib": "static-1.17290",
  "calling-global-api": "static-1.65971",
  "calling-internal-common": "static-1.31732",
  "calling-lifecycle-internal": "static-1.67353",
  "calling-lifecycle-messages": "static-1.59646",
  "commerce-products-lib": "static-1.10748",
  "crm-index-visualization-core": "static-1.4670",
  "crm-links": "static-1.6711",
  "customer-data-properties-shared-msw-handlers": "static-1.10119",
  "file-manager-components": "static-1.24728",
  "formula-editor": "static-1.14924",
  "google-libphonenumber": "static-1.48",
  "inbounddb-objects-service-types": "static-1.4489",
  "meetings-icalendar-utils-lib": "static-1.1047",
  "object-builder-ui-client": "static-1.49901",
  "pipeline-validation-client-types": "static-1.4248",
  "property-value-citations": "static-1.3482",
  "smart-data-capture-core": "static-1.341",
  "smart-property-lib": "static-1.8511",
  "tiered-pricing": "static-1.2131",
  "topics-actions-lib": "static-1.584",
  "trial-components-library": "static-1.14290",
  "ui-addon-iframeable": "static-1.9489",
  "zustand": "static-1.87",
  "final-form": "static-1.81",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.81",
  "rich-text-lib": "static-1.20458",
  "tinymce-themes": "static-1.57255",
  "data-token-picker": "static-1.17034",
  "hub-http-contrib": "static-1.3437",
  "interframe": "static-3.5152",
  "tinymce-data": "static-1.41370",
  "tinymce-plugins": "static-1.58399",
  "ui-addon-sales-email": "static-1.5614",
  "framework-data-schema-quick-fetch": "static-1.7210",
  "ui-addon-opt": "static-4.8785",
  "hubspot-apollo-cache": "static-1.744",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.559",
  "opentelemetry-web": "static-1.18",
  "beacon-keepalive-queue": "static-1.111",
  "purchase-motions-api": "static-1.6556",
  "onboarding-data-sync-lib": "static-1.2726",
  "growth-onboarding-next-action-components": "static-1.2903",
  "user-context-client": "static-1.4919",
  "idb-keyval": "static-1.54",
  "magpie-types": "static-1.5307",
  "nest": "static-1.646",
  "reactive-lib": "static-1.1133",
  "simple-logging-lib": "static-1.3463",
  "unified-auth-core-lib": "static-1.1405",
  "getting-started-shared-tasks-store": "static-1.18568",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1995",
  "integrations-error-boundary-lib": "static-1.14705",
  "integrations-tracking-lib": "static-1.6020",
  "native-integrations-shared-strings": "static-1.8173",
  "redux-observable": "static-1.78",
  "ReduxMessenger": "static-2.10781",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.1123",
  "calling-error-reporting": "static-1.31739",
  "shared-worker-versioning": "static-1.11451",
  "calling-usage-tracker": "static-1.6946",
  "voice-sms-access-library": "static-1.2301",
  "customer-data-tracking": "static-1.7283",
  "commerce-permissions": "static-1.1187",
  "products-iframe-lib": "static-1.8774",
  "products-ui-components-shared-msw-handlers": "static-1.11174",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10875",
  "sales-views-client-types": "static-1.4668",
  "location-customization-utils-lib": "static-1.10304",
  "apollo-dlb": "static-3.98",
  "immerable": "static-1.4553",
  "poll-commands": "static-1.3883",
  "video-components-external": "static-1.12317",
  "video-data-lib": "static-1.35975",
  "bark-lib": "static-1.16939",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.105",
  "crm-properties-common-lib": "static-1.6299",
  "react-codemirror": "static-1.11049",
  "data-agent-kit": "static-1.793",
  "feedback-loader": "static-1.29963",
  "fsm": "static-1.4163",
  "policy-lib": "static-1.7215",
  "react-colorpicker": "static-2.10621",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10938",
  "embedded-academy-lib": "static-1.15818",
  "hubs-service-types": "static-1.1673",
  "nudge-client-utils": "static-1.3305",
  "salesImages": "static-1.669",
  "FileManagerLib": "static-1.40368",
  "NamespacedHubStyle": "static-2.9324",
  "FileManagerCore": "static-1.40227",
  "content-assistance-lib": "static-1.8334",
  "layout-dnd-components": "static-1.13119",
  "layout-dnd-utils": "static-1.12094",
  "ui-addon-emoji-picker": "static-1.10278",
  "ui-brand-identity-lib": "static-1.16776",
  "InboxConnectUtils": "static-4.15736",
  "meetings-connect-utils-lib": "static-1.8026",
  "breeze-engine-chat-components": "static-1.973",
  "breeze-engine-core": "static-1.1273",
  "ably": "static-2.2",
  "highlight.js": "static-1.89",
  "universal-page-editor-lib": "static-1.3420",
  "adobe-sign-auth-lib": "static-1.653",
  "ads-unified-auth-lib": "static-1.1747",
  "custom-vendor-connection-lib": "static-1.173",
  "google-sheets-integration-lib": "static-1.1217",
  "microsoft-drive-auth-lib": "static-1.380",
  "surveymonkey-integration-lib": "static-1.749",
  "slack-ui-library": "static-1.10807",
  "calling-orchestration-schema": "static-1.37078",
  "crm-record-cards-service-types": "static-1.3834",
  "content-media-composition-data-lib": "static-1.13463",
  "content-media-compositions": "static-2.17470",
  "media-bridge-lib": "static-1.19548",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16554",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4917",
  "storybook-react": "static-1.43",
  "academy-common-lib": "static-1.15278",
  "nudge-custom-function-registry": "static-1.3062",
  "nudge-renderer-utils": "static-1.3381",
  "whisper-core-api": "static-1.7520",
  "audio-components": "static-1.6482",
  "FileManagerImages": "static-1.37879",
  "video-components": "static-1.14319",
  "breeze-artifacts-sdk": "static-1.659",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.64",
  "urlinator": "static-1.4926",
  "video-embed": "static-1.36809",
  "ui-addon-video-player": "static-1.9057",
  "ui-coaching-tips": "static-1.29494",
  "ContentData": "static-1.69405",
  "layout-data-lib": "static-1.10419",
  "academy-service-client": "static-1.4103",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4805",
  "trellis-ecosystem": "static-1.7761",
  "ui-addon-react-router-dom": "static-1.9940",
  "wootric-nps": "static-1.7262",
  "social-insights-client-types": "static-1.22823",
  "outpost": "static-1.4544",
  "growth-onboarding-feedback-components": "static-1.6994",
  "advanced-menus-core": "static-1.15718",
  "advanced-menus-lib": "static-1.12512",
  "ExportDialog": "static-6.10784",
  "ui-memberships-settings-lib": "static-1.35064",
  "marketplace-ui-apps-core": "static-1.19476",
  "marketplace-ui-common": "static-1.20944",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15717",
  "simple-menus-lib": "static-1.17234",
  "settings-ui-lib": "static-1.12939",
  "developer-experience-shared-components": "static-1.10947",
  "immutable-less": "static-1.5060",
  "marketplace-ui-client-types": "static-1.18351",
  "ui-addon-integrations-directory-panel": "static-2.8388",
  "ui-extensibility-client-types": "static-1.4326",
  "ai-settings-ui-library": "static-1.8482",
  "nav-meta": "static-1.30683",
  "ui-product-approvals-common": "static-1.1404",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4597",
  "simple-data-table": "static-1.3710"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35435",
  "atom": "/atom/static-1.5488",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2893",
  "client-types": "/client-types/static-1.505",
  "cssUtils": "/cssUtils/static-1.1031",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41202",
  "customer-data-objects": "/customer-data-objects/static-1.8103",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8464",
  "documents-lib": "/documents-lib/static-1.35440",
  "emoji-mart": "/emoji-mart/static-3.6",
  "flux-actions": "/flux-actions/static-1.378",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86736",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5123",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2606",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.114",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6000",
  "hs-test-utils": "/hs-test-utils/static-1.8449",
  "hub-http": "/hub-http/static-1.6619",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyle": "/HubStyle/static-2.12207",
  "HubStyleTokens": "/HubStyleTokens/static-2.11900",
  "I18n": "/I18n/static-7.1691",
  "icons": "/icons/static-2.699",
  "jasmine-immutable": "/jasmine-immutable/static-1.3371",
  "jasmine-runner": "/jasmine-runner/static-1.6858",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7561",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3297",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5790",
  "quartz": "/quartz/static-1.7581",
  "react": "/react/static-7.202",
  "react-dlb": "/react-dlb/static-1.92",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17143",
  "react-select-plus": "/react-select-plus/static-1.116",
  "react-utils": "/react-utils/static-2.5621",
  "react-virtualized": "/react-virtualized/static-2.110",
  "reference-resolvers": "/reference-resolvers/static-1.8590",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8514",
  "reporting-data": "/reporting-data/static-1.69158",
  "reporting-reports": "/reporting-reports/static-1.68834",
  "reporting-snowflake": "/reporting-snowflake/static-1.57774",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11091",
  "reporting-visualizations": "/reporting-visualizations/static-1.61232",
  "reselect": "/reselect/static-3.15",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9367",
  "sanitize": "/sanitize/static-1.4882",
  "sanitize-text": "/sanitize-text/static-1.8568",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2137",
  "signup-constants": "/signup-constants/static-1.19823",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8469",
  "StyleGuideUI": "/StyleGuideUI/static-3.512",
  "superstore": "/superstore/static-1.5169",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5156",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11337",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11512",
  "ui-images": "/ui-images/static-2.1269",
  "UIComponents": "/UIComponents/static-3.8846",
  "usage-tracker": "/usage-tracker/static-1.7723",
  "usage-tracker-container": "/usage-tracker-container/static-1.7713",
  "usage-tracker-core": "/usage-tracker-core/static-1.7573",
  "viral-links-lib": "/viral-links-lib/static-1.7489",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.10056",
  "foundations-components": "/foundations-components/static-1.8647",
  "immutable": "/immutable/static-2.88",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1359",
  "quartz-core": "/quartz-core/static-1.6800",
  "quick-fetch": "/quick-fetch/static-1.4190",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.83",
  "rpc-client-utils": "/rpc-client-utils/static-1.5079",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11557",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18506",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3858",
  "quartz-webpack": "/quartz-webpack/static-1.3805",
  "foundations-assets": "/foundations-assets/static-1.5296",
  "foundations-theming": "/foundations-theming/static-1.4890",
  "hub-http-janus": "/hub-http-janus/static-1.896",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10792",
  "hubspotter-http": "/hubspotter-http/static-1.4926",
  "sassPrefix": "/sassPrefix/static-1.298",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "crm-message-bus": "/crm-message-bus/static-1.43973",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23637",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13439",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13576",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10242",
  "events-data-lib": "/events-data-lib/static-1.657",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4287",
  "hs-resources": "/hs-resources/static-1.604",
  "immer": "/immer/static-1.104",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3739",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4107",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1412",
  "onboarding-scopes": "/onboarding-scopes/static-1.6862",
  "onboarding-tours": "/onboarding-tours/static-1.17295",
  "pulse": "/pulse/static-1.1048",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14655",
  "segments-client-types": "/segments-client-types/static-1.11943",
  "stylex": "/stylex/static-1.45",
  "trellis-assets": "/trellis-assets/static-1.2932",
  "trellis-components": "/trellis-components/static-1.2951",
  "trellis-theming": "/trellis-theming/static-1.1391",
  "ui-addon-teams": "/ui-addon-teams/static-1.21968",
  "quartz-auth": "/quartz-auth/static-1.1256",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9504",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5409",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9912",
  "ContentUtils": "/ContentUtils/static-1.69330",
  "customer-data-properties": "/customer-data-properties/static-1.52868",
  "forms-ai-lib": "/forms-ai-lib/static-1.4894",
  "forms-utils-lib": "/forms-utils-lib/static-1.13239",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6130",
  "react-dnd-compat": "/react-dnd-compat/static-1.5022",
  "react-tinymce": "/react-tinymce/static-1.56159",
  "tinymce-config": "/tinymce-config/static-2.55285",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10649",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3875",
  "HeadJS": "/HeadJS/static-2.811",
  "framer-motion": "/framer-motion/static-1.82",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3560",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.16",
  "testing-library": "/testing-library/static-1.162",
  "hs-locale-management": "/hs-locale-management/static-1.359",
  "ui-fonts": "/ui-fonts/static-1.1162",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4719",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1246",
  "web-vitals": "/web-vitals/static-1.18",
  "batch-promise": "/batch-promise/static-1.1956",
  "external-options-client-types": "/external-options-client-types/static-1.4407",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7305",
  "quartz-i18n": "/quartz-i18n/static-1.1256",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8328",
  "graphql": "/graphql/static-1.92",
  "persist-promise": "/persist-promise/static-1.4113",
  "reporting-client-types": "/reporting-client-types/static-1.2774",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.97",
  "growth-payments-core": "/growth-payments-core/static-1.26382",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5285",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1672",
  "quartz-routing": "/quartz-routing/static-1.1011",
  "hs-story-utils": "/hs-story-utils/static-1.9836",
  "react-flip-move": "/react-flip-move/static-1.81",
  "nested-table": "/nested-table/static-1.647",
  "seat-types-lib": "/seat-types-lib/static-1.927",
  "timezone-utils": "/timezone-utils/static-2.5641",
  "react-create-root-preference": "/react-create-root-preference/static-1.88",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4916",
  "floating-ui": "/floating-ui/static-1.66",
  "react-aria": "/react-aria/static-1.75",
  "tanstack-table": "/tanstack-table/static-1.64",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.195",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.593",
  "module-federation": "/module-federation/static-1.36",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.570",
  "quartz-test": "/quartz-test/static-1.1256",
  "quartz-tracking": "/quartz-tracking/static-1.960",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.489",
  "chirp-fetch": "/chirp-fetch/static-1.2310",
  "merchandise-lib": "/merchandise-lib/static-1.283",
  "purchase-motions-components": "/purchase-motions-components/static-1.6553",
  "ts-schema": "/ts-schema/static-1.4359",
  "bender-build-tools": "/bender-build-tools/static-1.3472",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3373",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1899",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5019",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4081",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4412",
  "event-emitter": "/event-emitter/static-1.1370",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.424",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3976",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19450",
  "growth-data-modal": "/growth-data-modal/static-1.6039",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3473",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2875",
  "navigation-components": "/navigation-components/static-1.19046",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5510",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1362",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10683",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8064",
  "ui-universal-auth": "/ui-universal-auth/static-1.9609",
  "user-context": "/user-context/static-1.5476",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.551",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6858",
  "stylex-utils": "/stylex-utils/static-1.158",
  "base-ui": "/base-ui/static-1.25",
  "react-day-picker": "/react-day-picker/static-1.13",
  "tanstack-virtual": "/tanstack-virtual/static-1.41",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10790",
  "magpie-lib": "/magpie-lib/static-1.5847",
  "navigation-messaging": "/navigation-messaging/static-1.8373",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.23468",
  "copilot-toolkit": "/copilot-toolkit/static-1.12032",
  "cms-field-types": "/cms-field-types/static-1.5223",
  "content-icons-ui": "/content-icons-ui/static-1.2417",
  "integrations-lib": "/integrations-lib/static-1.17290",
  "calling-global-api": "/calling-global-api/static-1.65971",
  "calling-internal-common": "/calling-internal-common/static-1.31732",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67353",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59646",
  "commerce-products-lib": "/commerce-products-lib/static-1.10748",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4670",
  "crm-links": "/crm-links/static-1.6711",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10119",
  "file-manager-components": "/file-manager-components/static-1.24728",
  "formula-editor": "/formula-editor/static-1.14924",
  "google-libphonenumber": "/google-libphonenumber/static-1.48",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4489",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1047",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49901",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4248",
  "property-value-citations": "/property-value-citations/static-1.3482",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.341",
  "smart-property-lib": "/smart-property-lib/static-1.8511",
  "tiered-pricing": "/tiered-pricing/static-1.2131",
  "topics-actions-lib": "/topics-actions-lib/static-1.584",
  "trial-components-library": "/trial-components-library/static-1.14290",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9489",
  "zustand": "/zustand/static-1.87",
  "final-form": "/final-form/static-1.81",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "rich-text-lib": "/rich-text-lib/static-1.20458",
  "tinymce-themes": "/tinymce-themes/static-1.57255",
  "data-token-picker": "/data-token-picker/static-1.17034",
  "hub-http-contrib": "/hub-http-contrib/static-1.3437",
  "interframe": "/interframe/static-3.5152",
  "tinymce-data": "/tinymce-data/static-1.41370",
  "tinymce-plugins": "/tinymce-plugins/static-1.58399",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5614",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7210",
  "ui-addon-opt": "/ui-addon-opt/static-4.8785",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.744",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.559",
  "opentelemetry-web": "/opentelemetry-web/static-1.18",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.111",
  "purchase-motions-api": "/purchase-motions-api/static-1.6556",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2726",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2903",
  "user-context-client": "/user-context-client/static-1.4919",
  "idb-keyval": "/idb-keyval/static-1.54",
  "magpie-types": "/magpie-types/static-1.5307",
  "nest": "/nest/static-1.646",
  "reactive-lib": "/reactive-lib/static-1.1133",
  "simple-logging-lib": "/simple-logging-lib/static-1.3463",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1405",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18568",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1995",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14705",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6020",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8173",
  "redux-observable": "/redux-observable/static-1.78",
  "ReduxMessenger": "/ReduxMessenger/static-2.10781",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.1123",
  "calling-error-reporting": "/calling-error-reporting/static-1.31739",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11451",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6946",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2301",
  "customer-data-tracking": "/customer-data-tracking/static-1.7283",
  "commerce-permissions": "/commerce-permissions/static-1.1187",
  "products-iframe-lib": "/products-iframe-lib/static-1.8774",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11174",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10875",
  "sales-views-client-types": "/sales-views-client-types/static-1.4668",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10304",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "immerable": "/immerable/static-1.4553",
  "poll-commands": "/poll-commands/static-1.3883",
  "video-components-external": "/video-components-external/static-1.12317",
  "video-data-lib": "/video-data-lib/static-1.35975",
  "bark-lib": "/bark-lib/static-1.16939",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.105",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6299",
  "react-codemirror": "/react-codemirror/static-1.11049",
  "data-agent-kit": "/data-agent-kit/static-1.793",
  "feedback-loader": "/feedback-loader/static-1.29963",
  "fsm": "/fsm/static-1.4163",
  "policy-lib": "/policy-lib/static-1.7215",
  "react-colorpicker": "/react-colorpicker/static-2.10621",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10938",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15818",
  "hubs-service-types": "/hubs-service-types/static-1.1673",
  "nudge-client-utils": "/nudge-client-utils/static-1.3305",
  "salesImages": "/salesImages/static-1.669",
  "FileManagerLib": "/FileManagerLib/static-1.40368",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9324",
  "FileManagerCore": "/FileManagerCore/static-1.40227",
  "content-assistance-lib": "/content-assistance-lib/static-1.8334",
  "layout-dnd-components": "/layout-dnd-components/static-1.13119",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12094",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10278",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16776",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15736",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8026",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.973",
  "breeze-engine-core": "/breeze-engine-core/static-1.1273",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.89",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3420",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.653",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1747",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.173",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1217",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.380",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.749",
  "slack-ui-library": "/slack-ui-library/static-1.10807",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37078",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3834",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13463",
  "content-media-compositions": "/content-media-compositions/static-2.17470",
  "media-bridge-lib": "/media-bridge-lib/static-1.19548",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16554",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4917",
  "storybook-react": "/storybook-react/static-1.43",
  "academy-common-lib": "/academy-common-lib/static-1.15278",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3062",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3381",
  "whisper-core-api": "/whisper-core-api/static-1.7520",
  "audio-components": "/audio-components/static-1.6482",
  "FileManagerImages": "/FileManagerImages/static-1.37879",
  "video-components": "/video-components/static-1.14319",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.659",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.64",
  "urlinator": "/urlinator/static-1.4926",
  "video-embed": "/video-embed/static-1.36809",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29494",
  "ContentData": "/ContentData/static-1.69405",
  "layout-data-lib": "/layout-data-lib/static-1.10419",
  "academy-service-client": "/academy-service-client/static-1.4103",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4805",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7761",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9940",
  "wootric-nps": "/wootric-nps/static-1.7262",
  "social-insights-client-types": "/social-insights-client-types/static-1.22823",
  "outpost": "/outpost/static-1.4544",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6994",
  "advanced-menus-core": "/advanced-menus-core/static-1.15718",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12512",
  "ExportDialog": "/ExportDialog/static-6.10784",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35064",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19476",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20944",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15717",
  "simple-menus-lib": "/simple-menus-lib/static-1.17234",
  "settings-ui-lib": "/settings-ui-lib/static-1.12939",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10947",
  "immutable-less": "/immutable-less/static-1.5060",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18351",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8388",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4326",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8482",
  "nav-meta": "/nav-meta/static-1.30683",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1404",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "simple-data-table": "/simple-data-table/static-1.3710"
}
};
